<section>
  <div class="logo"></div>
  <div class="form-container">
    <form [formGroup]="entity">
      <div class="col-12">
        <div class="main-title">
          Cambia tu contraseña
        </div>
        <p class="subtitle">
          Tu acceso se creó con una contraseña temporal. Por seguridad, debes definir una propia antes de continuar.
        </p>
      </div>
      <div class="grid">
        <div class="col-12">
          <p-messages [(value)]="responseMessage" [enableService]="showMessage" [closable]="true" [escape]="false"></p-messages>
        </div>
        <div class="col-12">
          <div class="field field-flex">
            <label for="currentPassword">
              <span class="p-error">*</span>Contraseña temporal (la que recibiste por correo):
            </label>
            <p-password [feedback]="false" placeholder="************" formControlName="currentPassword" [toggleMask]="true"></p-password>
            <ng-container *ngIf="entity.get('currentPassword')?.invalid && (entity.get('currentPassword')?.dirty || entity.get('currentPassword')?.touched)">
              <small class="p-error" *ngIf="entity.get('currentPassword')?.errors?.['required']">El campo es obligatorio.</small>
            </ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="field field-flex">
            <label for="newPassword">
              <span class="p-error">*</span>Nueva contraseña:
            </label>
            <p-password placeholder="************" formControlName="newPassword" [toggleMask]="true"></p-password>
            <ng-container *ngIf="entity.get('newPassword')?.invalid && (entity.get('newPassword')?.dirty || entity.get('newPassword')?.touched)">
              <small class="p-error" *ngIf="entity.get('newPassword')?.errors?.['required']">El campo es obligatorio.</small>
              <small class="p-error" *ngIf="entity.get('newPassword')?.errors?.['minlength']">La contraseña debe tener al menos 8 caracteres.</small>
              <small class="p-error" *ngIf="entity.get('newPassword')?.errors?.['pattern']">Debe contener al menos una mayúscula, una minúscula, un número y un carácter especial.</small>
            </ng-container>
          </div>
        </div>
        <div class="col-12">
          <div class="field field-flex">
            <label for="confirmPassword">
              <span class="p-error">*</span>Confirma la nueva contraseña:
            </label>
            <p-password [feedback]="false" placeholder="************" formControlName="confirmPassword" [toggleMask]="true"></p-password>
            <ng-container *ngIf="entity.get('confirmPassword')?.invalid && (entity.get('confirmPassword')?.dirty || entity.get('confirmPassword')?.touched)">
              <small class="p-error" *ngIf="entity.get('confirmPassword')?.errors?.['required']">El campo es obligatorio.</small>
            </ng-container>
          </div>
        </div>

        <div class="col-12 text-right">
          <button pButton pRipple label="Cerrar sesión" icon="fa-solid fa-arrow-right-from-bracket" class="p-button-text" (click)="logout()" [disabled]="submitting"></button>
          <button pButton pRipple label="Guardar contraseña" icon="fa-solid fa-key" class="p-button-success" (click)="submit()" [disabled]="entity.invalid || submitting"></button>
        </div>
      </div>
    </form>
  </div>
</section>
